import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type ListSliceState = {
  itemIdsToBePublished: string[]
}

const sliceInitialState: ListSliceState = {
  itemIdsToBePublished: [],
}

// TODO: migrate old List reducer to this modern RTK approach to creating reducers and actions.
const listSlice = createSlice({
  name: 'list',
  initialState: sliceInitialState,
  reducers: {
    setItemIdsToBePublished: (state, { payload }: PayloadAction<string[]>) => {
      state.itemIdsToBePublished = payload
    },
  },
})

export default listSlice.reducer

export const { setItemIdsToBePublished } = listSlice.actions
